export const REACT_APP_INGEST_API_HOST =
  process.env.REACT_APP_INGEST_API_HOST?.trim() || "inn.gs";
export const REACT_APP_INNGEST_SOURCE_KEY_ANALYTICS =
  process.env.REACT_APP_INNGEST_SOURCE_KEY_ANALYTICS?.trim();
export const REACT_APP_INNGEST_SOURCE_KEY_FEEDBACK =
  process.env.REACT_APP_INNGEST_SOURCE_KEY_FEEDBACK?.trim();
